import { z } from 'zod';
import { CnpjVO } from "../../../../common/validators/value-objects/cnpj.js";
import { BaseCompanyDTOSchema, } from "./companies.dto.js";
// Schema for input validation when updating a company
export const UpdateCompanyInputDTOSchema = BaseCompanyDTOSchema.omit({
    slug: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
}).extend({
    name: z.string().min(2).max(32),
    legalName: z.string().min(2).max(128),
    cnpj: CnpjVO,
    // Optional: omitted values keep the stored setting, so existing integrator payloads stay valid.
    requiresHandoff: z.boolean().optional(),
});
// Request and response schemas for the API layer
export const UpdateCompanyRequestDTOSchema = z.object({
    params: z.object({
        companyId: UpdateCompanyInputDTOSchema.shape.id,
    }),
    body: UpdateCompanyInputDTOSchema.omit({ id: true }),
});
//# sourceMappingURL=update-company.dto.js.map